import {
    CalculatorConstants,
} from '../constants/CalculatorConstants';
import {
    CalculatorInputFieldsType,
    CalculatorInputOptions,
} from './CalculatorInputValue';
import { CalculatorOutputType } from '../../../shared/classes/CalculatorOutputParams';
import { CalculatorHTMMode } from '../../../shared/classes/CalculatorMode';
import { calculatorHTMItemValues } from '../../../shared/constants/calculator_htm_item.constant';

export class CalculatorOutputFields {

    constructor(private readonly d: CalculatorInputFieldsType,
                private readonly calculatorMode: CalculatorHTMMode) {
    }

    private g(key: keyof CalculatorInputFieldsType): number {
        const formatValueFunction = CalculatorInputOptions[key]?.formatValueFunction;
        const value = +(this.d[key] || 0);

        return formatValueFunction?.(value) || value;
    }

    private getValueDataAliaColumnI(valueB: number, valueE: number): number {
        return (((valueE / valueB) < this.B23 ? (valueE / valueB) : this.B23) * valueB) || 0;
    }

    private getValueDataAliaColumnK(valueB: number, valueC: number): number {
        return ((valueC < this.B23 ? valueC : this.B23) * valueB) || 0;
    }

    private getValueDataAliaColumnL(valueB: number, valueJ: number): number {
        return (((valueJ < this.B23) ? (valueJ / valueB) : this.B23) * valueB) || 0;
    }

    private getValueDataASDColumnK(valueB: number, valueE: number, valueG: number): number {
        return ((valueB * valueE) / (valueB * valueG)) * (valueG * valueB * (1 + (this.R16_rate_HTM_org_performance / 100))) || 0;
    }

    private getValueDataASDColumnL(valueB: number, valueD: number, valueE: number, valueG: number): number {
        return (((valueE * valueB * valueD) / (valueB * valueG)) * (valueG * valueB * ( 1 + (this.R16_rate_HTM_org_performance / 100)))) || 0;
    }


    /** Calcul de l'onglet Data **/
    private B23 = this.g('I17_facility_opening_hours');
    private R16_rate_HTM_org_performance = this.g('R16_rate_HTM_org_performance') as typeof calculatorHTMItemValues[number]['code'];

    private I17 =
        this.getValueDataAliaColumnI(CalculatorConstants.B7, CalculatorConstants.E7) +
        this.getValueDataAliaColumnI(CalculatorConstants.B8, CalculatorConstants.E8) +
        this.getValueDataAliaColumnI(CalculatorConstants.B9, CalculatorConstants.E9) +
        this.getValueDataAliaColumnI(CalculatorConstants.B10, CalculatorConstants.E10) +
        this.getValueDataAliaColumnI(CalculatorConstants.B11, CalculatorConstants.E11) +
        this.getValueDataAliaColumnI(CalculatorConstants.B12, CalculatorConstants.E12) +
        this.getValueDataAliaColumnI(CalculatorConstants.B14, CalculatorConstants.E14) +
        this.getValueDataAliaColumnI(CalculatorConstants.B15, CalculatorConstants.E15) +
        this.getValueDataAliaColumnI(CalculatorConstants.B16, CalculatorConstants.E16);

    private K17 =
        this.getValueDataAliaColumnK(CalculatorConstants.B5, CalculatorConstants.C5) +
        this.getValueDataAliaColumnK(CalculatorConstants.B6, CalculatorConstants.C6) +
        this.getValueDataAliaColumnK(CalculatorConstants.B7, CalculatorConstants.C7) +
        this.getValueDataAliaColumnK(CalculatorConstants.B8, CalculatorConstants.C8) +
        this.getValueDataAliaColumnK(CalculatorConstants.B9, CalculatorConstants.C9) +
        this.getValueDataAliaColumnK(CalculatorConstants.B10, CalculatorConstants.C10) +
        this.getValueDataAliaColumnK(CalculatorConstants.B11, CalculatorConstants.C11) +
        this.getValueDataAliaColumnK(CalculatorConstants.B12, CalculatorConstants.C12) +
        this.getValueDataAliaColumnK(CalculatorConstants.B13, CalculatorConstants.C13) +
        this.getValueDataAliaColumnK(CalculatorConstants.B14, CalculatorConstants.C14) +
        this.getValueDataAliaColumnK(CalculatorConstants.B15, CalculatorConstants.C15) +
        this.getValueDataAliaColumnK(CalculatorConstants.B16, CalculatorConstants.C16);


    private L17 =
        this.getValueDataAliaColumnL(CalculatorConstants.B5, CalculatorConstants.J5) +
        this.getValueDataAliaColumnL(CalculatorConstants.B6, CalculatorConstants.J6) +
        this.getValueDataAliaColumnL(CalculatorConstants.B7, CalculatorConstants.J7) +
        this.getValueDataAliaColumnL(CalculatorConstants.B8, CalculatorConstants.J8) +
        this.getValueDataAliaColumnL(CalculatorConstants.B9, CalculatorConstants.J9) +
        this.getValueDataAliaColumnL(CalculatorConstants.B10, CalculatorConstants.J10) +
        this.getValueDataAliaColumnL(CalculatorConstants.B11, CalculatorConstants.J11) +
        this.getValueDataAliaColumnL(CalculatorConstants.B12, CalculatorConstants.J12) +
        this.getValueDataAliaColumnL(CalculatorConstants.B13, CalculatorConstants.J13) +
        this.getValueDataAliaColumnL(CalculatorConstants.B14, CalculatorConstants.J14) +
        this.getValueDataAliaColumnL(CalculatorConstants.B15, CalculatorConstants.J15) +
        this.getValueDataAliaColumnL(CalculatorConstants.B16, CalculatorConstants.J16);

    private K39=
        this.getValueDataASDColumnK(CalculatorConstants.B5, CalculatorConstants.E27, CalculatorConstants.G27) +
        this.getValueDataASDColumnK(CalculatorConstants.B6, CalculatorConstants.E28, CalculatorConstants.G28) +
        this.getValueDataASDColumnK(CalculatorConstants.B7, CalculatorConstants.E29, CalculatorConstants.G29) +
        this.getValueDataASDColumnK(CalculatorConstants.B8, CalculatorConstants.E30, CalculatorConstants.G30) +
        this.getValueDataASDColumnK(CalculatorConstants.B9, CalculatorConstants.E31, CalculatorConstants.G31) +
        this.getValueDataASDColumnK(CalculatorConstants.B10, CalculatorConstants.E32, CalculatorConstants.G32) +
        this.getValueDataASDColumnK(CalculatorConstants.B11, CalculatorConstants.E33, CalculatorConstants.G33) +
        this.getValueDataASDColumnK(CalculatorConstants.B12, CalculatorConstants.E34, CalculatorConstants.G34) +
        this.getValueDataASDColumnK(CalculatorConstants.B13, CalculatorConstants.E35, CalculatorConstants.G35) +
        this.getValueDataASDColumnK(CalculatorConstants.B14, CalculatorConstants.E36, CalculatorConstants.G36) +
        this.getValueDataASDColumnK(CalculatorConstants.B15, CalculatorConstants.E37, CalculatorConstants.G37) +
        this.getValueDataASDColumnK(CalculatorConstants.B16, CalculatorConstants.E38, CalculatorConstants.G38);



    private L39 =
        this.getValueDataASDColumnL(CalculatorConstants.B5, CalculatorConstants.D27, CalculatorConstants.E27, CalculatorConstants.G27) +
        this.getValueDataASDColumnL(CalculatorConstants.B6, CalculatorConstants.D28, CalculatorConstants.E28, CalculatorConstants.G28) +
        this.getValueDataASDColumnL(CalculatorConstants.B7, CalculatorConstants.D29, CalculatorConstants.E29, CalculatorConstants.G29) +
        this.getValueDataASDColumnL(CalculatorConstants.B8, CalculatorConstants.D30, CalculatorConstants.E30, CalculatorConstants.G30) +
        this.getValueDataASDColumnL(CalculatorConstants.B9, CalculatorConstants.D31, CalculatorConstants.E31, CalculatorConstants.G31) +
        this.getValueDataASDColumnL(CalculatorConstants.B10, CalculatorConstants.D32, CalculatorConstants.E32, CalculatorConstants.G32) +
        this.getValueDataASDColumnL(CalculatorConstants.B11, CalculatorConstants.D33, CalculatorConstants.E33, CalculatorConstants.G33) +
        this.getValueDataASDColumnL(CalculatorConstants.B12, CalculatorConstants.D34, CalculatorConstants.E34, CalculatorConstants.G34) +
        this.getValueDataASDColumnL(CalculatorConstants.B13, CalculatorConstants.D35, CalculatorConstants.E35, CalculatorConstants.G35) +
        this.getValueDataASDColumnL(CalculatorConstants.B14, CalculatorConstants.D36, CalculatorConstants.E36, CalculatorConstants.G36) +
        this.getValueDataASDColumnL(CalculatorConstants.B15, CalculatorConstants.D37, CalculatorConstants.E37, CalculatorConstants.G37) +
        this.getValueDataASDColumnL(CalculatorConstants.B16, CalculatorConstants.D38, CalculatorConstants.E38, CalculatorConstants.G38);

    /** fin données Data **/

    /** Données sans catégories **/
    public I53_average_number_of_exam_per_hour = this.g('I8_average_number_of_procedures_per_day') / this.g('I17_facility_opening_hours');
    private I55_yearlyradiographer_radiologist_wages = this.g('I17_facility_opening_hours') * (this.g('R8_#_of_radiologist')*this.g('AA12_radiologistwages_per_hour')+this.g('R10_#_of_radiographer')*this.g('AA10_radiographerwages_per_hour')) * this.g('I19_facility_opening_in_days_per_year');
    private R53_average_number_of_exams_per_year = this.g('I8_average_number_of_procedures_per_day') * this.g('I19_facility_opening_in_days_per_year');
    private AA53_estimated_revenue_per_year = this.R53_average_number_of_exams_per_year * this.g('I10_average_reimbursement_per_exams');

    /** OnWatch Predict **/
    private I61_nb_examinations_saved = Math.ceil(this.I17 * this.I53_average_number_of_exam_per_hour * (1 - this.g('I21_per_of_exams_rescheduled_after_an_event')));
    private I63_nb_revenue_saved = this.I61_nb_examinations_saved * this.g('I10_average_reimbursement_per_exams');
    private I65_nb_operating_hours_saved = this.I17;
    private I67_staff_iddle_time_cost_avoidance = this.I65_nb_operating_hours_saved * (this.g('R8_#_of_radiologist')*this.g('AA12_radiologistwages_per_hour') + this.g('R10_#_of_radiographer') * this.g('AA10_radiographerwages_per_hour'));
    private I69_staff_overtime_cost_avoidance = ((this.I61_nb_examinations_saved * this.g('I21_per_of_exams_rescheduled_after_an_event')) / this.I53_average_number_of_exam_per_hour) * (this.g('R8_#_of_radiologist') * this.g('AA12_radiologistwages_per_hour') * (1 + this.g('AA19_radiologist_overtime_wages_in_per')) + this.g('R10_#_of_radiographer') * this.g('AA10_radiographerwages_per_hour') * (1 + this.g('AA17_radiographer_overtime_wages_in_per')));
    private I71_average_admin_fee_costs_avoidance_for_rescheduling_exams = this.I61_nb_examinations_saved * this.g('AA8_admin_fee_per_rescheduled_patient');
    private I73_htm_estimated_labor_productivity_in_h = this.calculatorMode === CalculatorHTMMode.Direct ? 0 : this.K39;
    private I75_htm_estimated_productivity_in_dollar = this.g('R14_inhouse_engineer_cost_per_hour') * this.I73_htm_estimated_labor_productivity_in_h;
    private I77_imaging_dpt_estimated_benefits = this.calculatorMode === CalculatorHTMMode.Direct ? this.I63_nb_revenue_saved + this.I67_staff_iddle_time_cost_avoidance + this.I69_staff_overtime_cost_avoidance + this.I71_average_admin_fee_costs_avoidance_for_rescheduling_exams : this.I63_nb_revenue_saved + this.I67_staff_iddle_time_cost_avoidance + this.I69_staff_overtime_cost_avoidance + this.I71_average_admin_fee_costs_avoidance_for_rescheduling_exams + this.I75_htm_estimated_productivity_in_dollar;
    private I79_total_hospital_estimated_benefits = this.I77_imaging_dpt_estimated_benefits + this.I75_htm_estimated_productivity_in_dollar;
    private I81_nb_examinations_transfert_saved = Math.ceil(this.I61_nb_examinations_saved * this.g('K27_avg_transfer_rate_when_system_is_down'));
    private I83_nb_examinations_transfert_cost_saved = (this.I81_nb_examinations_transfert_saved * this.g('K29_transportation_fee_for_a_patient_transfer') + this.I81_nb_examinations_transfert_saved * this.g('K31_avg_transfer_time_including_exam_time_in_hours') * ((this.g('K35_#_of_doctor_clinician') * this.g('K37_doctor_clinician_wages_per_hours'))+(this.g('K39_#_of_nurses') * this.g('K41_nurses_wages_per_hour'))) + this.I81_nb_examinations_transfert_saved * this.g('I10_average_reimbursement_per_exams'));
    private I85_surgery_dpt_cost_saved = Math.ceil(this.I61_nb_examinations_saved * this.g('V27_avg_surgeries_requiring_diagnostic_imaging_prior_to_surgery')) * this.g('V41_avg_surgery_lenght_in_hours') * ((this.g('V29_#_of_surgeon') * this.g('V31_surgeon_avg_wages_per_hour')) + (this.g('V33_#_of_doctor_clinician') * this.g('V35_doctor_clinician_avg_wages_per_hour')) + (this.g('V37_#_of_nurses') * this.g('V39_nurses_wages_per_hour')));
    private I87_intensive_care_dpt_cost_saved = Math.ceil(this.I61_nb_examinations_saved * this.g('V27_avg_surgeries_requiring_diagnostic_imaging_prior_to_surgery')) * this.g('V43_avg_patient_intensive_care_lenght_in_hours') * this.g('V45_avg_cost_per_hour_in_the_intensive_care_dept');
    private I89_patient_transfer_surgery_dpt_benefits = this.I83_nb_examinations_transfert_cost_saved + this.I85_surgery_dpt_cost_saved + this.I87_intensive_care_dpt_cost_saved;
    private I91_totalhospital_estimated_benefits = this.I89_patient_transfer_surgery_dpt_benefits + this.I77_imaging_dpt_estimated_benefits;

    /** OnWatch **/
    private R61_nb_examinations_saved = Math.ceil(this.L17 * this.I53_average_number_of_exam_per_hour * (1 - this.g('I21_per_of_exams_rescheduled_after_an_event')));
    private R63_nb_revenue_saved = this.R61_nb_examinations_saved * this.g('I10_average_reimbursement_per_exams');
    private R65_nb_operating_hours_saved = Math.ceil(this.L17);
    private R67_staff_iddle_time_cost_avoidance = this.L17 * (this.g('R8_#_of_radiologist') * this.g('AA12_radiologistwages_per_hour') + this.g('R10_#_of_radiographer') * this.g('AA10_radiographerwages_per_hour'));
    private R69_staff_overtime_cost_avoidance = ((this.R61_nb_examinations_saved * this.g('I21_per_of_exams_rescheduled_after_an_event')) / this.I53_average_number_of_exam_per_hour) * (this.g('R8_#_of_radiologist') * this.g('AA12_radiologistwages_per_hour') * (1 + this.g('AA19_radiologist_overtime_wages_in_per')) + this.g('R10_#_of_radiographer') * this.g('AA10_radiographerwages_per_hour') * (1 + this.g('AA17_radiographer_overtime_wages_in_per')));
    private R71_average_admin_fee_costs_avoidance_for_rescheduling_exams = this.R61_nb_examinations_saved * this.g('AA8_admin_fee_per_rescheduled_patient');
    private R73_htm_estimated_productivity_in_h = this.calculatorMode === CalculatorHTMMode.Direct ? 0 : this.L39;
    private R75_htm_estimated_productivity_in_dollar = this.g('R14_inhouse_engineer_cost_per_hour') * this.R73_htm_estimated_productivity_in_h;
    private R77_imaging_dpt_estimated_benefits = this.calculatorMode === CalculatorHTMMode.Direct ? this.R63_nb_revenue_saved + this.R67_staff_iddle_time_cost_avoidance + this.R69_staff_overtime_cost_avoidance + this.R71_average_admin_fee_costs_avoidance_for_rescheduling_exams : this.R63_nb_revenue_saved + this.R67_staff_iddle_time_cost_avoidance + this.R69_staff_overtime_cost_avoidance + this.R71_average_admin_fee_costs_avoidance_for_rescheduling_exams + this.R75_htm_estimated_productivity_in_dollar;
    private R81_nb_examinations_transfert_saved =  Math.floor(this.R61_nb_examinations_saved * this.g('K27_avg_transfer_rate_when_system_is_down'));
    private R83_nb_examinations_transfert_cost_saved = (this.R81_nb_examinations_transfert_saved * this.g('K29_transportation_fee_for_a_patient_transfer') + this.R81_nb_examinations_transfert_saved * this.g('K31_avg_transfer_time_including_exam_time_in_hours') * ((this.g('K35_#_of_doctor_clinician') * this.g('K37_doctor_clinician_wages_per_hours')) + (this.g('K39_#_of_nurses') * this.g('K41_nurses_wages_per_hour'))) + this.R81_nb_examinations_transfert_saved * this.g('R10_#_of_radiographer') + this.R81_nb_examinations_transfert_saved * this.g('I10_average_reimbursement_per_exams'));
    private R85_surgery_dpt_cost_saved = Math.ceil(this.R61_nb_examinations_saved * this.g('V27_avg_surgeries_requiring_diagnostic_imaging_prior_to_surgery')) * this.g('V41_avg_surgery_lenght_in_hours') * ((this.g('V29_#_of_surgeon') * this.g('V31_surgeon_avg_wages_per_hour')) + (this.g('V33_#_of_doctor_clinician') * this.g('V35_doctor_clinician_avg_wages_per_hour')) + (this.g('V37_#_of_nurses') * this.g('V39_nurses_wages_per_hour')));
    private R87_intensive_care_dpt_cost_saved = Math.ceil(this.R61_nb_examinations_saved * this.g('V27_avg_surgeries_requiring_diagnostic_imaging_prior_to_surgery')) * this.g('V43_avg_patient_intensive_care_lenght_in_hours') * this.g('V45_avg_cost_per_hour_in_the_intensive_care_dept');
    private R89_patient_transfer_surgery_dpt_benefits = this.R83_nb_examinations_transfert_cost_saved + this.R85_surgery_dpt_cost_saved + this.R87_intensive_care_dpt_cost_saved;
    private R91_total_hospital_estimated_benefits = this.R89_patient_transfer_surgery_dpt_benefits + this.R77_imaging_dpt_estimated_benefits;

    /** Break and Fix **/
    private AA61_exams_loss = Math.ceil(this.K17 * this.I53_average_number_of_exam_per_hour * (1 - this.g('I21_per_of_exams_rescheduled_after_an_event')));
    private AA63_revenue_loss = this.AA61_exams_loss * this.g('I10_average_reimbursement_per_exams');
    private AA65_nb_operating_hours_lost = this.K17;
    private AA67_staff_cost_due_to_iddle_time = this.AA65_nb_operating_hours_lost * (this.g('R8_#_of_radiologist') * this.g('AA12_radiologistwages_per_hour') + this.g('R10_#_of_radiographer') * this.g('AA10_radiographerwages_per_hour'));
    private AA69_staff_overtime_cost = ((this.AA61_exams_loss * this.g('I21_per_of_exams_rescheduled_after_an_event')) / this.I53_average_number_of_exam_per_hour) * (this.g('R8_#_of_radiologist') * this.g('AA12_radiologistwages_per_hour') * (1 + this.g('AA19_radiologist_overtime_wages_in_per')) + this.g('R10_#_of_radiographer') * this.g('AA10_radiographerwages_per_hour') * (1 + this.g('AA17_radiographer_overtime_wages_in_per')));
    private AA71_average_admin_fee_costs_for_rescheduling_exams =  this.AA61_exams_loss * this.g('AA8_admin_fee_per_rescheduled_patient');
    private AA73_html_est_productivity_in_h = 0; // Valeur non utilisée sur IGS
    private AA75_htm_est_productivity_in_dollar = 0; // Valeur non utilisée sur IGS
    private AA77_imaging_dpt_estimated_loss = this.AA63_revenue_loss + this.AA67_staff_cost_due_to_iddle_time + this.AA69_staff_overtime_cost + this.AA71_average_admin_fee_costs_for_rescheduling_exams;
    private AA81_examinations_transfert_lost = Math.ceil(this.AA61_exams_loss * this.g('K27_avg_transfer_rate_when_system_is_down'));
    private AA83_examiniations_transfert_cost_loss = (this.AA81_examinations_transfert_lost * this.g('K29_transportation_fee_for_a_patient_transfer') + this.AA81_examinations_transfert_lost * this.g('K31_avg_transfer_time_including_exam_time_in_hours') * ((this.g('K35_#_of_doctor_clinician') * this.g('K37_doctor_clinician_wages_per_hours')) + (this.g('K39_#_of_nurses') * this.g('K41_nurses_wages_per_hour'))) + this.AA81_examinations_transfert_lost * this.g('I10_average_reimbursement_per_exams'));
    private AA85_surgery_dpt_cost_loss = Math.ceil(this.AA61_exams_loss * this.g('V27_avg_surgeries_requiring_diagnostic_imaging_prior_to_surgery')) * this.g('V41_avg_surgery_lenght_in_hours') * ((this.g('V29_#_of_surgeon') * this.g('V31_surgeon_avg_wages_per_hour')) + (this.g('V33_#_of_doctor_clinician') * this.g('V35_doctor_clinician_avg_wages_per_hour')) + (this.g('V37_#_of_nurses') * this.g('V39_nurses_wages_per_hour')));
    private AA87_intensive_care_dpt_cost_loss = Math.ceil(this.AA61_exams_loss * this.g('V27_avg_surgeries_requiring_diagnostic_imaging_prior_to_surgery')) * this.g('V43_avg_patient_intensive_care_lenght_in_hours') * this.g('V45_avg_cost_per_hour_in_the_intensive_care_dept');
    private AA89_patient_transfer_surgery_dpt_loss = this.AA83_examiniations_transfert_cost_loss + this.AA85_surgery_dpt_cost_loss; // todo - surement une erreur dans l'excel, colonne qui n'existe pas
    private AA91_total_hospital_estimated_loss = this.AA77_imaging_dpt_estimated_loss + this.AA89_patient_transfer_surgery_dpt_loss;

    values = {
        I53_average_number_of_exam_per_hour: {
            value: this.I53_average_number_of_exam_per_hour,
            label: 'Average number of exam per hour',
            options: {
                round: false,
            }
        },
        I55_yearlyradiographer_radiologist_wages: {
            value: this.I55_yearlyradiographer_radiologist_wages,
            label: 'Yearly Radiographer & Radiologist Wages',
            options: {
                displayCurrency: true,
            }
        },
        R53_average_number_of_exams_per_year: {
            value: this.R53_average_number_of_exams_per_year,
            label: 'Average number of exam per year',
            options: {
                displayCurrency: true,
            }
        },
        AA53_estimated_revenue_per_year: {
            value: this.AA53_estimated_revenue_per_year,
            label: 'Estimated revenue per year',
            options: {
                displayCurrency: true,
            }
        },
        I61_nb_examinations_saved: {
            value: this.I61_nb_examinations_saved || 0,
            label: '# Examinations Saved',
        },
        I63_nb_revenue_saved: {
            value: this.I63_nb_revenue_saved || 0,
            label: '# Revenue Saved',
            options: {
                displayCurrency: true,
            }
        },
        I65_nb_operating_hours_saved: {
            value: this.I65_nb_operating_hours_saved || 0,
            label: '# Operating hours Saved',
        },
        I67_staff_iddle_time_cost_avoidance: {
            value: this.I67_staff_iddle_time_cost_avoidance,
            label: 'Staff idle time cost avoidance',
            options: {
                displayCurrency: true,
            }
        },
        I69_staff_overtime_cost_avoidance: {
            value: this.I69_staff_overtime_cost_avoidance,
            label: 'Staff Overtime Cost avoidance',
            options: {
                displayCurrency: true,
            }
        },
        I71_average_admin_fee_costs_avoidance_for_rescheduling_exams: {
            value: this.I71_average_admin_fee_costs_avoidance_for_rescheduling_exams,
            label: 'Average Admin Fee costs avoidance for rescheduling Exams',
            options: {
                displayCurrency: true,
            }
        },
        I73_htm_estimated_labor_productivity_in_h: {
            value: this.I73_htm_estimated_labor_productivity_in_h,
            label: 'HTM\'s estimated labor productivity in H',
        },
        I75_htm_estimated_productivity_in_dollar: {
            value: this.I75_htm_estimated_productivity_in_dollar || 0,
            label: 'HTM\'s estimated productivity in money',
            options: {
                displayCurrency: true,
            }
        },
        I77_imaging_dpt_estimated_benefits: {
            value: this.I77_imaging_dpt_estimated_benefits,
            label: 'Imaging Dpt Estimated Benefits',
            options: {
                displayCurrency: true,
            }
        },
        I79_total_hospital_estimated_benefits: {
            value: this.I79_total_hospital_estimated_benefits,
            label: 'Total Hospital Estimated Benefits'
        },
        I81_nb_examinations_transfert_saved: {
            value: this.I81_nb_examinations_transfert_saved,
            label: ' # Examinations Transfert Saved',
        },
        I83_nb_examinations_transfert_cost_saved: {
            value: this.I83_nb_examinations_transfert_cost_saved,
            label: ' # Examinations Transfert Cost Saved',
            options: {
                displayCurrency: true,
            }
        },
        I85_surgery_dpt_cost_saved: {
            value: this.I85_surgery_dpt_cost_saved,
            label: ' Surgery Dpt cost saved',
            options: {
                displayCurrency: true,
            }
        },
        I87_intensive_care_dpt_cost_saved: {
            value: this.I87_intensive_care_dpt_cost_saved,
            label: 'Intensive Care Dpt cost saved',
            options: {
                displayCurrency: true,
            }
        },
        I89_patient_transfer_surgery_dpt_benefits: {
            value: this.I89_patient_transfer_surgery_dpt_benefits,
            label: 'Patient Transfer + Surgery Dpt Benefits',
            options: {
                displayCurrency: true,
            }
        },
        I91_totalhospital_estimated_benefits: {
            value: this.I91_totalhospital_estimated_benefits,
            label: 'Total Hospital Estimated Benefits',
            options: {
                displayCurrency: true,
            }
        },
        R61_nb_examinations_saved: {
            value: this.R61_nb_examinations_saved,
            label: '# Examinations Saved',
        },
        R63_nb_revenue_saved: {
            value: this.R63_nb_revenue_saved,
            label: '# Revenue Saved',
            options: {
                displayCurrency: true,
            }
        },
        R65_nb_operating_hours_saved: {
            value: this.R65_nb_operating_hours_saved,
            label: ' # Operating Hours Saved',
        },
        R67_staff_iddle_time_cost_avoidance: {
            value: this.R67_staff_iddle_time_cost_avoidance,
            label: 'Staff idle time cost avoidance',
            options: {
                displayCurrency: true,
            }
        },
        R69_staff_overtime_cost_avoidance: {
            value: this.R69_staff_overtime_cost_avoidance,
            label: 'Staff Overtime Cost avoidance',
            options: {
                displayCurrency: true,
            }
        },
        R71_average_admin_fee_costs_avoidance_for_rescheduling_exams: {
            value: this.R71_average_admin_fee_costs_avoidance_for_rescheduling_exams,
            label: 'Average Admin Fee costs avoidance for rescheduling Exams',
            options: {
                displayCurrency: true,
            }
        },
        R73_htm_estimated_productivity_in_h: {
            value: this.R73_htm_estimated_productivity_in_h,
            label: 'HTM\'s estimated Productivity in H'
        },
        R75_htm_estimated_productivity_in_dollar: {
            value: this.R75_htm_estimated_productivity_in_dollar,
            label: 'HTM\'s estimated productivity in money',
            options: {
                displayCurrency: true,
            }
        },
        R77_imaging_dpt_estimated_benefits: {
            value: this.R77_imaging_dpt_estimated_benefits,
            label: 'Imaging DPT Estimated Benefits',
            options: {
                displayCurrency: true,
            }
        },
        R81_nb_examinations_transfert_saved: {
            value: this.R81_nb_examinations_transfert_saved,
            label: '# Examinations Transfert Saved',
        },
        R83_nb_examinations_transfert_cost_saved: {
            value: this.R83_nb_examinations_transfert_cost_saved,
            label: '# Examinations Transfert Cost Saved',
            options: {
                displayCurrency: true,
            }
        },
        R85_surgery_dpt_cost_saved: {
            value: this.R85_surgery_dpt_cost_saved,
            label: 'Surgery Dpt cost saved',
            options: {
                displayCurrency: true,
            }
        },
        R87_intensive_care_dpt_cost_saved: {
            value: this.R87_intensive_care_dpt_cost_saved,
            label: 'Intensive Care Dpt cost  saved',
            options: {
                displayCurrency: true,
            }
        },
        R89_patient_transfer_surgery_dpt_benefits: {
            value: this.R89_patient_transfer_surgery_dpt_benefits,
            label: 'Patient Transfer + Surgery Dpt Benefits',
            options: {
                displayCurrency: true,
            }
        },
        R91_total_hospital_estimated_benefits: {
            value: this.R91_total_hospital_estimated_benefits,
            label: 'Total Hospital Estimated Benefits',
            options: {
                displayCurrency: true,
            }
        },
        AA61_exams_loss: {
            value: this.AA61_exams_loss,
            label: 'Exams loss'
        },
        AA63_revenue_loss: {
            value: this.AA63_revenue_loss,
            label: 'Revenue Loss',
            options: {
                displayCurrency: true,
            }
        },
        AA65_nb_operating_hours_lost: {
            value: this.AA65_nb_operating_hours_lost,
            label: '# Operating hours Lost'
        },
        AA67_staff_cost_due_to_iddle_time: {
            value: this.AA67_staff_cost_due_to_iddle_time,
            label: 'Staff cost due to iddle time',
            options: {
                displayCurrency: true,
            }
        },
        AA69_staff_overtime_cost: {
            value: this.AA69_staff_overtime_cost,
            label: 'Staff Overtime cost',
            options: {
                displayCurrency: true,
            }
        },
        AA71_average_admin_fee_costs_for_rescheduling_exams: {
            value: this.AA71_average_admin_fee_costs_for_rescheduling_exams,
            label: 'Average Admin Fee costs for rescheduling Exams',
            options: {
                displayCurrency: true,
            }
        },
        AA73_html_est_productivity_in_h: {
            value: this.AA73_html_est_productivity_in_h,
            label: 'HTM\'s est productivity  in H'
        },
        AA75_htm_est_productivity_in_dollar: {
            value: this.AA75_htm_est_productivity_in_dollar || 0,
            label: 'HTM\'s est productivity in money',
            options: {
                displayCurrency: true,
            }
        },
        AA77_imaging_dpt_estimated_loss: {
            value: this.AA77_imaging_dpt_estimated_loss,
            label: 'Imaging Dpt Estimated Loss',
            options: {
                displayCurrency: true,
            }
        },
        AA81_examinations_transfert_lost: {
            value: this.AA81_examinations_transfert_lost,
            label: 'Examinations Transfert Lost'
        },
        AA83_examiniations_transfert_cost_loss: {
            value: this.AA83_examiniations_transfert_cost_loss,
            label: ' # Examinations Transfert Cost Loss',
            options: {
                displayCurrency: true,
            }
        },
        AA85_surgery_dpt_cost_loss: {
            value: this.AA85_surgery_dpt_cost_loss,
            label: 'Surgery Dpt cost loss',
            options: {
                displayCurrency: true,
            }
        },
        AA87_intensive_care_dpt_cost_loss: {
            value: this.AA87_intensive_care_dpt_cost_loss,
            label: 'Intensive Care Dpt cost loss',
            options: {
                displayCurrency: true,
            }
        },
        AA89_patient_transfer_surgery_dpt_loss: {
            value: this.AA89_patient_transfer_surgery_dpt_loss,
            label: 'Patient Transfer + Surgery Dpt Loss',
            options: {
                displayCurrency: true,
            }
        },
        AA91_total_hospital_estimated_loss: {
            value: this.AA91_total_hospital_estimated_loss,
            label: 'Total Hospital Estimated Loss',
            options: {
                displayCurrency: true,
            }
        }
    } satisfies CalculatorOutputType;
}
